import onLoad from '../../../javascripts/utils/onLoad';

onLoad<HTMLDivElement>('.richtext', async ($editor) => {
  const { default: useRichtext } = await import(
    /* webpackChunkName: "use-richtext" */ './useRichtext'
  );

  useRichtext($editor);
});
